export default "__VITE_ASSET__CGdI5FeW__"